<script setup>
import { useRouter, useRoute } from 'vue-router';
import { computed } from 'vue';
import '@/assets/tailwind.css';
import AppHeader from './components/AppHeader.vue';
import AppFooter from './components/AppFooter.vue';

const router = useRouter();
const route = useRoute();

const activePage = computed(() => {
  if (route.path === '/') return 'home';
  // Strip leading slash if it exists for consistency with how components use activePage
  return route.path.substring(1) || 'home';
});

const navigate = (page) => {
  if (page === 'home') {
    router.push('/');
  } else if (page.startsWith('/')) {
    router.push(page);
  } else {
    router.push({ name: page });
  }
};
</script> 



<template>
    <div class="min-h-screen flex flex-col">
        <AppHeader :navigate="navigate" :active-page="activePage" />

        <main class="flex-grow">
            <router-view v-slot="{ Component }">
                <transition name="fade-slide" mode="out-in">
                    <component :is="Component" :navigate="navigate" />
                </transition>
            </router-view>
        </main>

        <AppFooter :navigate="navigate" />
    </div>
</template>

<style>
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
}
.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(12px);
}
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

@media (prefers-reduced-motion: reduce) {
  .fade-slide-enter-active,
  .fade-slide-leave-active {
    transition: none;
  }
}
</style>
